module.exports = __webpack_public_path__ + "static/img/division_5.7e8b916.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_5.svg
// module id = 4UdF
// module chunks = 38